import type * as api from '@gitbook/api-client';
import { SPACE_DEFAULT_TITLE } from '@gitbook/app-database';
import { HeadTitle } from '@gitbook/util-react-head';

/**
 * HTML `<head>` title for the space.
 */
export function SpaceHeadTitle(props: { title: string; space: api.Space }) {
    const { title, space } = props;
    return <HeadTitle title={`${title} - ${space.title || SPACE_DEFAULT_TITLE}`} />;
}
